/**
 * Tiny bilingual helper.
 *
 * Content is stored as either a plain string (same in every language) or a
 * `{ pt, en }` record. `t()` resolves it for the active language.
 *
 * To add a new language: extend `Lang`, add the key to every `Record<Lang, …>`
 * value in `src/data/profile.ts`, and add a toggle button in the header.
 */

export type Lang = "pt" | "en";

/** A value that may be language-specific. */
export type Localized = string | Record<Lang, string>;

/** Resolve a localized value for the active language. */
export function t(value: Localized, lang: Lang): string {
  return typeof value === "string" ? value : value[lang];
}
